import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import Swal from "sweetalert2";

import {
  Backdrop,
  BackdropRoot,
  createTheme,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import axios from "axios";
import sha512 from "crypto-js/sha512";
import { HistoryToggleOffRounded } from "@mui/icons-material";
import { Link, useHistory } from "react-router-dom";
import fireLogo from "../../assets/images/firebird.png";
import EmailIcon from "@mui/icons-material/Email";
import { xCheckSumIdGernator } from "../../helper/helper";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

export default function SendOtp() {
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState("d-none");
  // const [timer, setTimer] = useState(60);
  const [disabled, setDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const history = useHistory();
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  const resetTimer = function () {
    if (!timer) {
      setTimer(29);
    }
  };

  useEffect(() => {
    if (timer == 0) {
      setDisplay("d-none");
    } else {
      setDisplay("");
    }
  }, [timer]);

  // const timeOutCallback = useCallback(
  //   () => setTimer((currTimer) => currTimer - 1),
  //   []
  // );
  // useEffect(() => {
  //   timer > 0 && setTimeout(timeOutCallback, 1000);
  // }, [timer, timeOutCallback]);

  // const resetTimer = function () {
  //   if (!timer) {
  //     setTimer(59);
  //   }
  // };

  const validationSchema = yup.object({
    otp: yup
      .number("Enter OTP")
      // .email("E-Mail must be valid")

      .min(1000, "OTP should be of minimum 4 characters length"),
    // .required("Username is required"),
  });
  const formik = useFormik({
    initialValues: {
      otp: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        // const generator = Math.floor(Math.random() * 100000000);
        // const allValues = `${values.otp}${generator}54IzSRi`;
        // const allValuesHashed = sha512(allValues).toString();
        const xCheckSumValues = xCheckSumIdGernator(
          localStorage.getItem("transaction")
        );
        setOpen(true);
        // const res = await axios.post(
        //   `${process.env.REACT_APP_COMMON_API}/auth/v1/forget/password/`,
        //   {
        //     email: values.email,
        //     requestId: generator,
        //     isDebug: false,
        //   },
        //   {
        //     headers: {
        //       "X-CHECKSUM-ID": allValuesHashed,
        //     },
        //   }
        // );
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/auth/v1/forget/password/verify-otp`,
          {
            msisdn: `${localStorage.getItem("values")}`,
            otp: values.otp,
            transactionId: `${localStorage.getItem("transaction")}`,
            requestId: xCheckSumValues.generator,
            isDebug: false,
          },
          {
            headers: {
              "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
            },
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);

          await setTimeout(async () => {
            // await setDisabled(true);
            // await toast.success("Otp verified successfully", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text: "Otp verified successfully",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
          await history.replace("/forgot/updatepassword");

          await setDisplay();
        } else {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.error(res.data.statusDescription.description, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescription.description,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
          await setDisplay();
        }
      } catch (error) {
        setOpen(false);

        await setTimeout(async () => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ToastContainer autoClose={4000} />
        <ThemeProvider theme={theme}>
          <div class="container-fluid px-0">
            <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
              <div class="col-md-7 bg_18 d-flex">
                <div class="ps_8 my-auto py_5">
                  <img src={fireLogo} class="img-fluid d-block mx-auto" />
                  <p class="text-center m-0 mt-4">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                  </p>
                </div>
              </div>
              <div
                class="col-md-5 d-flex align-items-center bg_8 p-4"
                style={{ padding: "3.5rem" }}
              >
                <div class="w-100">
                  <form onSubmit={formik.handleSubmit}>
                    <div class="" id="sign_in">
                      <div class="">
                        <div class="text-center">
                          <i class="fas fa-lock lock p-2"></i>
                        </div>
                        <div class="text-center mt-2">
                          <span class="d-inline-block text-capitalize">
                            Verify Otp
                          </span>
                        </div>
                      </div>
                      <div class="my-4">
                        <div class="input-group input-group-outline input_field">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <VpnKeyIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Enter Your Otp Here"
                              name="otp"
                              type="number"
                              variant="standard"
                              size="small"
                              value={formik.values.otp}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.otp && Boolean(formik.errors.otp)
                              }
                              helperText={
                                formik.touched.otp && formik.errors.otp
                              }
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn bg-gradient-primary register_grad d-block w-100 m-0"
                        // disabled={timer != 0}
                        // onClick={() => {
                        //   // resetTimer();
                        //   formik.handleSubmit();
                        // }}
                      >
                        Verify
                        {/* <span className={`${display}`}>
                          {" "}
                          in:{timer} seconds
                        </span> */}
                      </button>
                      <div className="row my-3">
                        <div className="col-md-6">
                          <div className="text-start fw-bold">
                            <a
                              href="#"
                              onClick={formik.handleReset}
                              class="text-capitalize link-info"
                            >
                              Reset
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            class="text-end  fw-bold link-info"
                            id="sign_up_in"
                          >
                            <Link to="/" class="text-capitalize">
                              Log In
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
